<div class="container-fluid p-4">
  <div class="row">
    <div class="col-12">
      <p-card>
        <ng-template pTemplate="header">
          <div class="p-4">
            <h2 class="mb-0">
              <i class="pi pi-file-pdf me-2"></i>
              PDF Template Tester
            </h2>
            <p class="text-muted mb-0 mt-2">Test and preview all available invoice PDF templates</p>
          </div>
        </ng-template>

        <div class="row mb-4">
          <div class="col-md-6">
            <label for="templateSelect" class="form-label fw-bold">Select Template:</label>
            <p-dropdown
              id="templateSelect"
              [(ngModel)]="selectedTemplate"
              [options]="availableTemplates"
              optionLabel="label"
              optionValue="value"
              placeholder="Choose a template"
              styleClass="w-100">
            </p-dropdown>
          </div>
          <div class="col-md-6 d-flex align-items-end">
            <p-button
              label="Template Info"
              icon="pi pi-info-circle"
              severity="info"
              (onClick)="getTemplateInfo()"
              styleClass="me-2">
            </p-button>
            <p-button
              label="Test All Templates"
              icon="pi pi-bolt"
              severity="warning"
              (onClick)="testAllTemplates()">
            </p-button>
          </div>
        </div>

        <p-panel header="Invoice Testing" [toggleable]="true" [collapsed]="false" styleClass="mb-3">
          <div class="d-flex flex-wrap gap-2">
            <p-button
              label="Download Invoice"
              icon="pi pi-download"
              severity="success"
              (onClick)="generateInvoice()">
            </p-button>
            <p-button
              label="Open Invoice"
              icon="pi pi-external-link"
              severity="info"
              (onClick)="openInvoice()">
            </p-button>
            <p-button
              label="Print Invoice"
              icon="pi pi-print"
              severity="secondary"
              (onClick)="printInvoice()">
            </p-button>
          </div>
          
          <div class="mt-3">
            <h6 class="fw-bold">Sample Invoice Data:</h6>
            <ul class="small">
              <li>Invoice Number: {{ sampleInvoiceData.invoiceNumber }}</li>
              <li>Customer: {{ sampleInvoiceData.customerName }} ({{ sampleInvoiceData.customerMobile }})</li>
              <li>Items: {{ sampleInvoiceData.items.length }} products</li>
              <li>Total Amount: {{ sampleInvoiceData.totalAmount | currency:'INR' }}</li>
              <li>Payment: {{ sampleInvoiceData.paymentMethod }}</li>
            </ul>
          </div>
        </p-panel>

        <p-panel header="Quotation Testing" [toggleable]="true" [collapsed]="false">
          <div class="d-flex flex-wrap gap-2">
            <p-button
              label="Download Quotation"
              icon="pi pi-download"
              severity="success"
              (onClick)="generateQuotation()">
            </p-button>
            <p-button
              label="Open Quotation"
              icon="pi pi-external-link"
              severity="info"
              (onClick)="openQuotation()">
            </p-button>
            <p-button
              label="Print Quotation"
              icon="pi pi-print"
              severity="secondary"
              (onClick)="printQuotation()">
            </p-button>
          </div>
          
          <div class="mt-3">
            <h6 class="fw-bold">Sample Quotation Data:</h6>
            <ul class="small">
              <li>Quotation Number: {{ sampleQuotationData.invoiceNumber }}</li>
              <li>Customer: {{ sampleQuotationData.customerName }} ({{ sampleQuotationData.customerMobile }})</li>
              <li>Items: {{ sampleQuotationData.items.length }} products</li>
              <li>Total Amount: {{ sampleQuotationData.totalAmount | currency:'INR' }}</li>
              <li>Valid Until: {{ sampleQuotationData.quotationValidityDate | date:'mediumDate' }}</li>
            </ul>
          </div>
        </p-panel>

        <ng-template pTemplate="footer">
          <div class="alert alert-info mb-0">
            <i class="pi pi-info-circle me-2"></i>
            <strong>Available Templates:</strong>
            <ul class="mb-0 mt-2">
              <li><strong>default</strong> - Thermal printer (80mm POS paper)</li>
              <li><strong>new-jaffer</strong> - A3 size professional invoice</li>
              <li><strong>rathna-shree</strong> - A5 size compact invoice</li>
              <li><strong>ptr-enterprise</strong> - A4 size standard invoice</li>
            </ul>
          </div>
        </ng-template>
      </p-card>
    </div>
  </div>
</div>

